<template>
  <PInputCombobox
    ref="inputCombobox"
    v-bind="{ ...$attrs, ...props }"
    v-model="selectedUnit"
    :items="unitList"
    items-key-name="key"
    items-value-name="value"
    :items-filter-fn="
      (item, query) =>
        item.value.includes(query.toLowerCase()) || item.alternative.includes(query.toLowerCase())
    "
    :editable="false"
  >
    <template v-if="$slots['before-input']" #before-input>
      <slot name="before-input" />
    </template>
  </PInputCombobox>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from "vue"
import type { Units } from "@/enums/units.enum"
import { getUnitList } from "@/helper/enums/unit-helper"
import PInputCombobox from "./PInputCombox.vue"

defineOptions({ inheritAttrs: false })

const props = withDefaults(
  defineProps<{
    disabled?: boolean
    inputPlaceholder?: string
    inputClass?: string
  }>(),
  { disabled: undefined }
)
const modelValue = defineModel<Units | undefined>()
const unitList = getUnitList()
type UnitOption = (typeof unitList)[number]
const selectedUnit = computed<UnitOption | undefined>({
  get: () => unitList.find((unit) => unit.key.toString() === modelValue.value?.toString()),
  set: (unit) => (modelValue.value = unit?.key)
})
const inputCombobox = useTemplateRef("inputCombobox")
defineExpose({
  focus: () => inputCombobox.value?.focus()
})
</script>
